<!--  -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="接替状态">
    </el-page-header>
  <!-- <div class="navbar">
      <div class="nav-l">
        <el-input
          clearable
          style="width: 24.0rem"
          v-model="search"
          placeholder="请搜索成员姓名"
          @change="onSearch"
        >
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="nav-r"></div>
      </div> -->
    <div class="mMain">
      <div class="container">
        <el-table ref="multipleTable"  :data="tableData" tooltip-effect="dark" border
          v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
          <el-table-column prop="external_name" label="客户名称" min-width="120" header-align="center" show-overflow-tooltip
            align="center"></el-table-column>
          <el-table-column prop="status_name" label="	接替状态" min-width="120" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">
              <div :style="{ color: colors[scope.row.status - 1] }">
                {{ scope.row.status_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="takeover_time" label="	接替时间	" min-width="120" show-overflow-tooltip header-align="center"
            align="center"></el-table-column>
        </el-table>
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "departureInheritanceState",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      colors: ["#67C23A", "#E6A23C", "#F56C6C", "#F56C6C"],
      tableData: [],
      multipleSelection: [],
      userid: "",
      title: "",
      person: {
        name: "",
        id: "",
      },
      module: "",
      cursor: "",
      loading: true,
      noMore: false,
      checkbox: false
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    }
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.getData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
    },
    load() {
      this.loading = true
      this.getData()
    },
    getData() {
      this.axios
        .post(
          "/crm/Dimission/transferResult2",
          qs.stringify({
            phone: this.tooken.phone,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            limit: 2,
            cursor: this.cursor,
            handover_userid: this.$route.query.handover_userid,
            takeover_userid: this.$route.query.takeover_userid,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          const data = res.data;
          if (data.code == 1) {
            this.loading = false
            this.tableData.push(...data.data.data);
            this.cursor = data.data.next_cursor;
            if (!this.cursor) {
              this.noMore = true;
            }
          }
        })
        .catch(function (err) {
          this.loading = false
        });
    },
    onSelection(val) {
      this.multipleSelection = val;
    },
    onSearch() {
      this.tableData = [];
      this.getData();
    },
    handlePreview() { },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped></style>